import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGE_SIZE } from "../../constants";
import { useGetSupportTicketsQuery } from "./supportTicketApiSlice";
import {
  CenteredLoader,
  EmptyCard,
  ErrorNote,
  ListPagination,
  Page,
  PageBody,
  PageHeader,
  TicketList,
  useIsNarrow,
} from "./supportTicketChrome";

/** 내 피드백 — the trainee's own tickets. Same chrome as 지원 요청 관리, minus the 작성자
 *  column, because every row here is theirs. */
const MySupportTicketsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const page_size = queryParams.get("page_size") || PAGE_SIZE;
  const isNarrow = useIsNarrow();

  const { data, isLoading, isError } = useGetSupportTicketsQuery({ page, page_size });

  const handlePaginationChange = (event, { activePage }) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("page", activePage);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const tickets = data?.results || [];
  const totalPages = data?.count ? Math.ceil(data.count / page_size) : 1;

  return (
    <Page>
      <PageHeader
        icon="comment alternate outline"
        title="내 피드백"
        subtitle="제출한 피드백과 관리자 답변 확인"
      />
      <PageBody>
        {isLoading && <CenteredLoader />}
        {isError && <ErrorNote>피드백 목록을 불러오지 못했습니다.</ErrorNote>}

        {!isLoading && !isError && tickets.length === 0 && (
          <EmptyCard icon="comment outline">
            아직 제출한 피드백이 없습니다.
            <br />
            화면 우하단의 <b>피드백 보내기</b> 버튼으로 보내 주세요.
          </EmptyCard>
        )}

        {!isLoading && !isError && tickets.length > 0 && (
          <>
            <TicketList
              tickets={tickets}
              onOpen={(ticket) => navigate(`/my-feedback/${ticket.id}`)}
              isNarrow={isNarrow}
            />
            <ListPagination
              page={page}
              totalPages={totalPages}
              onChange={handlePaginationChange}
            />
          </>
        )}
      </PageBody>
    </Page>
  );
};

export default MySupportTicketsPage;
